export function findItemById<TObject>(
  source: Record<string, any>,
  id: string,
  nestedKey?: string
): TObject | undefined {
  const keyToDigDeeper = nestedKey ?? 'children';

  for (const key in source) {
    var item = source[key];
    if (item.id === id) return item;

    // Item not returned yet. Search its children by recursive call.
    if (item[keyToDigDeeper]) {
      let subresult = findItemById(item[keyToDigDeeper], id);

      // If the item was found in the subchildren, return it.
      if (subresult) {
        return subresult as TObject;
      }
    }
  }
  // Nothing found yet? return null.
  return undefined;
}
